import React from "react";
import { DatePicker } from "antd";

const GenericDatePicker = ({ value, onChange }) => {
  return (
    <DatePicker value={value} onChange={onChange} className="custom-date" />
  );
};

export default GenericDatePicker;
